
/* production */
export const url = `https%3A%2F%2Fafats.nknu.edu.tw%2Fline_login`
export const client_id = `2007154403`
export const token_url = `https%3A%2F%2Feducation.orange-technic.com%2Fqrcode%2Fnotify_bind`
export const token_client_id = `tHfRuZas1qTMaSs9kBA4hA`
/* production */

/* test */
// export const url = `https%3A%2F%2Fwww.orange-technic.com%3A7444%2Fline_login`
// export const client_id = `2002932828`
// export const token_url = `https%3A%2F%2Fwww.orange-technic.com%3A7443%2Fqrcode%2Fnotify_bind`
// export const token_client_id = `gJ5FlzywDgVRHR9M502M5A`
/* test */

/* develop */
// export const url = `http%3A%2F%2Flocalhost%3A3000%2Fline_login`
// export const client_id = `2000738382`
// export const token_url = `http%3A%2F%2Flocalhost%3A8082%2Fqrcode%2Fnotify_bind`
// export const token_client_id = `GZcZQFjJvSnOEhQAPhvzVi`
/* develop */